require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./the-most-important-things-for-heart.json") })
        }
      }, "path---the-most-important-things-for-heart");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---the-most-important-things-for-heart!./.cache/json/the-most-important-things-for-heart.json
// module id = 595
// module chunks = 231608221292675